/** 헤더·행 간격 일치용 (프리셉터/직군 on·off 동일 적용) */
export const NURSE_LIST_COLUMNS = {
  handle: "40px",
  name: "80px",
  preceptor: "30px",
  // age: "50px",
  grade: "80px",
  role: "40px",
  experience: "40px",
} as const;
